import { Component } from '@angular/core';
import { StatusButtons } from "../../../_shared/interfaces";
import { NgForOf } from "@angular/common";
import { WarehouseOverviewComponent } from "../warehouse-overview/warehouse-overview.component";

@Component({
  selector: 'app-warehouse',
  standalone: true,
  imports: [
    NgForOf,
    WarehouseOverviewComponent,
  ],
  templateUrl: './warehouse.component.html',
  styleUrl: './warehouse.component.sass'
})

export class WarehouseComponent {
  status: string = 'movements';

  statusButtons: StatusButtons[] = [
    { state: 'movements',  display: 'Alle Warenbewegungen', label: 'alert-info',    icon: 'info-circle'},
    { state: 'incoming',   display: 'Wareneingänge',        label: 'label-success', icon: 'info-circle'},
    { state: 'outgoing',   display: 'Warenausgänge',        label: 'alert-danger',  icon: 'info-circle'},
    { state: 'provision',  display: 'Beistellungen',        label: 'label-blue',    icon: 'info-circle'},
    { state: 'stock_init', display: 'Lager initialisiert',  label: 'label-purple',  icon: 'info-circle'},
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }

}
